import apolloClient from '@/graphql/apollo'
import { CHECKOUT } from '@/graphql/mutations/purchase'

const checkout = async function(context, { cartId, provider, shipping }) {
  const response = await apolloClient.mutate({
    mutation: CHECKOUT,
    variables: {
      cartId,
      provider,
      selectedShipping: {
        shippingName: shipping.shippingName,
        destinationPostalCode: shipping.destinationPostalCode,
        service: shipping.service
      }
    }
  })

  context.commit('SET_PROVIDER_CHECKOUT_URL', response.data)
}

export default {
  checkout
}
